import { render, staticRenderFns } from "./NonShepaTransfers.vue?vue&type=template&id=1a5cd2fb&scoped=true"
import script from "./NonShepaTransfers.vue?vue&type=script&lang=js"
export * from "./NonShepaTransfers.vue?vue&type=script&lang=js"
import style0 from "./NonShepaTransfers.vue?vue&type=style&index=0&id=1a5cd2fb&prod&scoped=true&lang=css"
import style1 from "./NonShepaTransfers.vue?vue&type=style&index=1&id=1a5cd2fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5cd2fb",
  null
  
)

export default component.exports